import { memo, ReactNode, useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';
import Card from '../../../../common/card';
import UsageSummary from './usage-summary';
import BillingInformation from './billing-information';
import { convertToKebabCase } from '../../../../../constants/helpers/text';
import { ClientStatusContext, PORTAL_PRIVILEGE } from '../../../../common/client-status';

interface DashboardCard {
  title: string;
  portalPrivilege: PORTAL_PRIVILEGE | null;
  render: () => ReactNode;
}

const cardsDefs: DashboardCard[] = [
  {
    title: 'Billing information',
    portalPrivilege: 'OPERATION_HISTORY',
    render: () => <BillingInformation />
  },
  {
    title: 'Usage Summary',
    portalPrivilege: 'OPERATION_HISTORY',
    render: () => <UsageSummary />
  }
];

const useStyles = makeStyles(theme => ({
  gridContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    position: 'absolute',
    paddingRight: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing(3),
      alignItems: 'center'
    },
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
      overflowY: 'auto',
      paddingLeft: theme.spacing(3),
      verticalAlign: 'top',
      display: 'inline'
    },
    [theme.breakpoints.down('sm')]: {
      height: 'max-content'
    }
  },
  cardContainer: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      height: '100%',
      width: '50%',
      marginLeft: theme.spacing(3)
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: 'max-content',
      marginBottom: theme.spacing(3)
    },
    [theme.breakpoints.down('sm')]: {
      height: 'max-content'
    }
  }
}));

const Dashboard = () => {
  const classes = useStyles();
  const { checkIfUserHasPortalPrivilege } = useContext(ClientStatusContext);

  const cards = cardsDefs
    .filter(c => c.portalPrivilege !== null && checkIfUserHasPortalPrivilege(c.portalPrivilege))
    .map(card => ({
      title: card.title,
      content: card.render()
    }));

  return (
    <Box data-testid="with-layout-box" className={classes.gridContainer}>
      {cards.map(({ title, content }) => (
        <Box data-testid={`card-${convertToKebabCase(title)}`} className={classes.cardContainer} key={title}>
          <Card title={title} content={content} />
        </Box>
      ))}
    </Box>
  );
};
export default memo(Dashboard);
